// extracted by mini-css-extract-plugin
export const home__article_card = "HomeArticleItem-module--home__article_card--2KSm0";
export const home__article_thumbnail = "HomeArticleItem-module--home__article_thumbnail--WnnG1";
export const home__article_content = "HomeArticleItem-module--home__article_content--6z8fP";
export const home__article_name = "HomeArticleItem-module--home__article_name--1hCxV";
export const home__article_details = "HomeArticleItem-module--home__article_details--3uAuK";
export const home__article_excerpt = "HomeArticleItem-module--home__article_excerpt--3kDbb";